import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { Input } from '../Input/Input';

/**
 * `InputPassword` allows the user to toggle between
 * inputting hidden or visible characters.
 */
export var InputPassword = function InputPassword(props) {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      visible = _React$useState2[0],
      setVisible = _React$useState2[1];

  return /*#__PURE__*/React.createElement(Input, _extends({
    placeholder: "Password",
    label: "Password"
  }, props, {
    type: visible ? 'text' : 'password',
    actionLabel: visible ? 'Hide' : 'Show',
    actionProps: {
      onClick: function onClick() {
        return setVisible(function (v) {
          return !v;
        });
      }
    }
  }));
};